var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5973_9833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6741 7.59844L3.95312 6.39844V15.2652C3.95312 15.6702 4.27757 15.9984 4.6778 15.9984H16.275C16.6752 15.9984 16.9996 15.6702 16.9996 15.2652V11.9984L10.6741 7.59844Z",
    fill: "#185C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6741 0H4.6778C4.27757 0 3.95312 0.328263 3.95312 0.733198V4L10.6741 8L14.2322 9.2L16.9996 8V4L10.6741 0Z",
    fill: "#21A366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.95312 4H10.6741V8H3.95312V4Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.76334 3.19922H3.95312V13.1992H8.76334C9.16302 13.1979 9.48671 12.8704 9.48801 12.466V3.93242C9.48671 3.52803 9.16302 3.20053 8.76334 3.19922Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.36799 3.60156H3.95312V13.6016H8.36799C8.76767 13.6002 9.09136 13.2728 9.09266 12.8684V4.33476C9.09136 3.93037 8.76767 3.60288 8.36799 3.60156Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.36799 3.60156H3.95312V12.8016H8.36799C8.76767 12.8002 9.09136 12.4728 9.09266 12.0684V4.33476C9.09136 3.93037 8.76767 3.60288 8.36799 3.60156Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.97264 3.60156H3.95312V12.8016H7.97264C8.37232 12.8002 8.69601 12.4728 8.69731 12.0684V4.33476C8.69601 3.93037 8.37232 3.60288 7.97264 3.60156Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.724673 3.60156H7.97299C8.37322 3.60156 8.69767 3.92983 8.69767 4.33476V11.6684C8.69767 12.0733 8.37322 12.4016 7.97299 12.4016H0.724673C0.324446 12.4016 0 12.0733 0 11.6684V4.33476C0 3.92983 0.324446 3.60156 0.724673 3.60156Z",
    fill: "url(#paint0_linear_5973_9833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.24609 10.384L3.77056 7.99399L2.37379 5.61719H3.49737L4.2596 7.13719C4.32998 7.28159 4.37821 7.38879 4.40431 7.45958H4.41419C4.46426 7.34438 4.51698 7.23252 4.57233 7.12398L5.38714 5.61799H6.4186L4.98625 7.98079L6.45498 10.384H5.35749L4.47705 8.71559C4.43558 8.64461 4.40038 8.57004 4.37189 8.49279H4.35885C4.33305 8.56847 4.29883 8.64094 4.25684 8.70879L3.35031 10.384H2.24609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2767 0H10.6758V4H17.0014V0.733198C17.0014 0.328263 16.6769 0 16.2767 0Z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6758 8H17.0014V12H10.6758V8Z",
    fill: "#107C41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5973_9833",
    x1: 1.51096,
    y1: 3.02865,
    x2: 7.28687,
    y2: 12.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5973_9833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.7d25896696eb7ece8e70b43a0e2ec264.svg";
export { ForwardRef as ReactComponent };